class EvenementModel {
    constructor(titre,date,dateFin,lieu,payslieu,logo,cliquable){
        this.titre = titre
        this.date = date
        this.dateFin = dateFin
        this.lieu = lieu
        this.payslieu = payslieu
        this.logo = logo
        this.cliquable = cliquable
    }

    static fromJSON(json) {
        return new EvenementModel(json.titre, json.date, json.dateFin, json.lieu, json.payslieu, json.logo, json.cliquable);
    }
}

export default EvenementModel;